import * as React from "react"

const SvgComponentHome = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" {...props}>
    <path
      style={{
        fill: "rgb(185, 185, 185)",
      }}
      d="M25 9.094 7.281 25.374h5.563v15.532h24.312V25.375h5.563L25 9.094z"
    />
  </svg>
)

export default SvgComponentHome;